// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file vision/membership/v1/leave_vision_project.proto (package protos.vision.membership.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file vision/membership/v1/leave_vision_project.proto.
 */
export const file_vision_membership_v1_leave_vision_project: GenFile = /*@__PURE__*/
  fileDesc("Ci92aXNpb24vbWVtYmVyc2hpcC92MS9sZWF2ZV92aXNpb25fcHJvamVjdC5wcm90bxIbcHJvdG9zLnZpc2lvbi5tZW1iZXJzaGlwLnYxIogBChlMZWF2ZVZpc2lvblByb2plY3RSZXF1ZXN0Ek0KBnBhcmFtcxgBIAEoCzI9LnByb3Rvcy52aXNpb24ubWVtYmVyc2hpcC52MS5MZWF2ZVZpc2lvblByb2plY3RSZXF1ZXN0LlBhcmFtcxocCgZQYXJhbXMSEgoKcHJvamVjdF9pZBgBIAEoCSJ2ChpMZWF2ZVZpc2lvblByb2plY3RSZXNwb25zZRJOCgZyZXN1bHQYASABKAsyPi5wcm90b3MudmlzaW9uLm1lbWJlcnNoaXAudjEuTGVhdmVWaXNpb25Qcm9qZWN0UmVzcG9uc2UuUmVzdWx0GggKBlJlc3VsdGIGcHJvdG8z");

/**
 * @generated from message protos.vision.membership.v1.LeaveVisionProjectRequest
 */
export type LeaveVisionProjectRequest = Message<"protos.vision.membership.v1.LeaveVisionProjectRequest"> & {
  /**
   * @generated from field: protos.vision.membership.v1.LeaveVisionProjectRequest.Params params = 1;
   */
  params?: LeaveVisionProjectRequest_Params | undefined;
};

/**
 * Describes the message protos.vision.membership.v1.LeaveVisionProjectRequest.
 * Use `create(LeaveVisionProjectRequestSchema)` to create a new message.
 */
export const LeaveVisionProjectRequestSchema: GenMessage<LeaveVisionProjectRequest> = /*@__PURE__*/
  messageDesc(file_vision_membership_v1_leave_vision_project, 0);

/**
 * @generated from message protos.vision.membership.v1.LeaveVisionProjectRequest.Params
 */
export type LeaveVisionProjectRequest_Params = Message<"protos.vision.membership.v1.LeaveVisionProjectRequest.Params"> & {
  /**
   * @generated from field: string project_id = 1;
   */
  projectId: string;
};

/**
 * Describes the message protos.vision.membership.v1.LeaveVisionProjectRequest.Params.
 * Use `create(LeaveVisionProjectRequest_ParamsSchema)` to create a new message.
 */
export const LeaveVisionProjectRequest_ParamsSchema: GenMessage<LeaveVisionProjectRequest_Params> = /*@__PURE__*/
  messageDesc(file_vision_membership_v1_leave_vision_project, 0, 0);

/**
 * @generated from message protos.vision.membership.v1.LeaveVisionProjectResponse
 */
export type LeaveVisionProjectResponse = Message<"protos.vision.membership.v1.LeaveVisionProjectResponse"> & {
  /**
   * @generated from field: protos.vision.membership.v1.LeaveVisionProjectResponse.Result result = 1;
   */
  result?: LeaveVisionProjectResponse_Result | undefined;
};

/**
 * Describes the message protos.vision.membership.v1.LeaveVisionProjectResponse.
 * Use `create(LeaveVisionProjectResponseSchema)` to create a new message.
 */
export const LeaveVisionProjectResponseSchema: GenMessage<LeaveVisionProjectResponse> = /*@__PURE__*/
  messageDesc(file_vision_membership_v1_leave_vision_project, 1);

/**
 * @generated from message protos.vision.membership.v1.LeaveVisionProjectResponse.Result
 */
export type LeaveVisionProjectResponse_Result = Message<"protos.vision.membership.v1.LeaveVisionProjectResponse.Result"> & {
};

/**
 * Describes the message protos.vision.membership.v1.LeaveVisionProjectResponse.Result.
 * Use `create(LeaveVisionProjectResponse_ResultSchema)` to create a new message.
 */
export const LeaveVisionProjectResponse_ResultSchema: GenMessage<LeaveVisionProjectResponse_Result> = /*@__PURE__*/
  messageDesc(file_vision_membership_v1_leave_vision_project, 1, 0);

